<template>
  <div
    :class="{ 'isEnhanced': result.enhanced }"
    class="Search Search--jobs"
  >
    <div :class="[{ 'isFeatured': featured }, 'Search-content']">
      <figure class="Search-companyLogo">
        <a
          :href="result.url"
          :title="result.company.name + ' ' + result.title "
          class="company-search-logo"
        >
          <img
            v-if="result.company.small_logo"
            :src="result.company.small_logo"
            :alt="result.company.name"
            width="58"
            height="58"
            loading="lazy"
          >
          <img
            v-else
            :src="defaultLogo"
            :alt="result.company.name"
            width="58"
            height="58"
            loading="lazy"
          >
        </a>
      </figure>

      <a
        :href="result.url"
        :title="result.company.name + ' ' + result.title "
        class="Search-descriptions"
      >

        <h2
          :title="result.title"
          class="Job-titleHeader"
        >{{ result.title }}</h2>

        <p class="Search-industry"><i class="far   fa-briefcase" />
          {{ result.company.name }}</p>
        <ul
          :class="{'u-noMargin' : result.company.is_ted && result.company.ted_details.paid}"
          class="Search-label"
        >
          <li
            v-if="result.deadline"
            class="deadline"
          >
            <span class="far fa-calendar-alt" /> {{ result.deadline }}
          </li>
          <li
            v-if="result.salary"
            class="salary"
          ><span class="far fa-coins" /> <span v-html="result.salary" />
          </li>
          <li
            v-if="result.job_type_text"
            class="duration"
          >
            <span class="far fa-briefcase" /> {{ result.job_type_text }}
          </li>
          <li
            v-if="result.jobLocations"
            class="company"
          >
            <span class="far fa-map-marker-alt" /> {{ result.jobLocations }}
          </li>
        </ul>

        <div
          v-if="result.company.is_ted && result.company.ted_details.paid"
          class="Search-ted"
        >
          <tooltip>
            <template #trigger>
              <span
                class="Tag Tag--purple Tag--small"
              >
                <i class="far fa-trophy" /> {{ result.company.ted_label }}
              </span>
            </template>
            <template #tip>
              <span> {{ tooltipForTopEmployer }}</span>
            </template>
          </tooltip>
        </div>
      </a>

      <div
        v-if="showSaveItemButton"
        class="icon-cta"
      >
        <save-item-button
          :id="result.id"
          :company-id="result.company.id"
          :company-name="result.company.name"
          :title="result.title"
          :url="result.url"
          :is-register-interest="result.is_pre_reg"
          type="jobs"
        />
        <a
          :href="result.url"
          :title="result.company.name + ' ' + result.title "
          class="Button Button--primary mobile"
        ><span>View Job</span></a>
      </div>
      <div
        v-if="result.enhanced"
        class="Search-enhancedText"
      >
        <p>
          {{ result.enhanced.quote }}
          <rating
            :rating="roundNumber(result.enhanced.reviews.rating,1)"
            class="isInline"
          />
          <a :href="result.enhanced.reviews.url">{{ result.enhanced.reviews.number_of_reviews }} reviews</a>
        </p>
        <a
          :href="result.url"
          class="text-link"
        >View full job description</a>
      </div>
    </div>
  </div>
</template>

<script>
import { roundNumber } from '@/filters';
import SaveItemButton from '../../common/save-item-button.vue';
import ReviewRatingStars from '../../common/review-rating-stars.vue';
import Tooltip from '../../common/rmp-tool-tip.vue';

export default {
  name: 'JobResult',

  components: {
    SaveItemButton,
    rating: ReviewRatingStars,
    tooltip: Tooltip,
  },
  props: {
    result: {
      type: Object,
      required: true,
      default() {
        return {};
      },
    },
    showSaveItemButton: {
      type: Boolean,
      default: true,
    },
    featured: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      roundNumber,
      defaultLogo: `${RMP_CDN_URL}/assets/placeholder.png`,
    };
  },

  computed: {
    tooltipForTopEmployer() {
      return `${this.result.company.ted_details.rank_ordinal} in ${this.result.company.ted_details.type_name} table`;
    },
  },
};
</script>

<style type="text/scss" lang="scss" scoped>
.fa-trophy {
  margin-right: 5px;
}
.SearchResult-wrapper {
  margin-bottom: 20px;
  padding-bottom: 20px;
  border-bottom: 1px solid #d1d1d1;
}

.SearchResult-review {
  display: flex;
  align-content: space-between;

}

.SearchResult-reviewLogo {
  flex: 0 0 75px;
  margin-right: 30px;

  img {
    width: 75px;
  }
}

.Search-content .Search-descriptions .Search-industry {
  font-size: 16px;
}

.SearchResult-reviewContent {
  flex: 1;

  ul {
    margin-bottom: 0;
    list-style-type: none;
    display: flex;
  }
  li {
    margin-right: 10px;
  }
}

.SearchResult-reviewTitle {
  font-size: 18px;
  margin: 0;
}

.SearchResult-reviewQuote {
  margin-bottom: 0;
}

.SearchResult-shortlist {
  flex: 0 0 50px;
  text-align: right;
}

.SearchResult-reviewRatingScore {
  padding: 5px;
  background: #d1d1d1;
}

.rating-stars {
  &.isInline {
    display: inline-block;
  }
}

</style>
